module.exports = __webpack_public_path__ + "static/media/medical_cert_p3_2.4008a318.png";